module.exports = __webpack_public_path__ + "static/media/bulkUsersNomination.21f68f7b.xls";